import React, { FC } from "react";
import { ThemeBuilderSectionLine } from "../WidgetThemeBuilder/ThemeBuilderSectionLine";
import { WidgetValuePicker, WidgetValuePickerChildrenProps } from "../WidgetThemeBuilder/WidgetValuePicker";
import { Select, Input } from "@xapp/components";
import style from "../WidgetThemeBuilder/style.scss";

export interface SearchWidgetLineHeightPickerProps {
    readonly label?: string;
    readonly value: string | undefined;
    readonly defaultValue: string | undefined;
    readonly required?: boolean;
    onChange(value: string): void;
}

export const SearchWidgetLineHeightPickerRaw: FC<WidgetValuePickerChildrenProps<string>> = ({
    required,
    value,
    override,
    onChange
}: WidgetValuePickerChildrenProps<string>) => {

    const re = /(\d+)(.+)/;
    const parts = value ? value.match(re) : undefined;
    const num = value ? (parts ? parts[1] : 0) : "";
    const unit = parts ? parts[2] : "px";

    function handleValChange(value: number) {
        const raw = value;

        if (isNaN(raw) && !required) {
            onChange(``);
        } else {
            onChange(`${raw}${unit !== "num" ? unit : ""}`);
        }
    }

    function handleUnitChange(value: string) {
        onChange(`${num}${value !== "num" ? value : ""}`);
    }

    const items = [
        { label: "num", value: "num" },
        { label: "em", value: "em" },
        { label: "px", value: "px" },
        { label: "rem", value: "rem" }
    ];

    return (<>
        <Input
            className={style.lengthPickerValue}
            type="number" value={num}
            disabled={override} onChange={(value: number) => handleValChange(value)} />
        <Select
            items={items}
            className={style.lengthPickerUnit}
            value={unit}
            disabled={override}
            onChange={handleUnitChange} />
    </>);
};

export const SearchWidgetLineHeightPicker: FC<SearchWidgetLineHeightPickerProps> = ({
    label,
    value,
    defaultValue,
    required,
    onChange
}: SearchWidgetLineHeightPickerProps) => {
    return (
        <ThemeBuilderSectionLine label={label ?? "Line height"}>
            <div className={style.lengthPicker}>
                <WidgetValuePicker<string>
                    value={value}
                    defaultValue={defaultValue}
                    children={SearchWidgetLineHeightPickerRaw}
                    onChange={onChange}
                    required={required}
                />
            </div>
        </ThemeBuilderSectionLine>
    );
};